import React, { Component } from "react";
import ConfirmationDialog from "../dialogs/ConfirmationDialog";

export default class EditTemplate extends Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      showNavigateAwayConfirmation: false,
      hasEdit: false,
      detectEdit: true,
      name: null,
    };
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    const { detectEdit } = this.state;
    if (prevProps.detectEdit !== this.props.detectEdit)
      this.setState({ detectEdit: this.props.detectEdit });
    else if (detectEdit) this.detectEdits(this.props.compare);
  }

  componentWillUnmount() {
    // Clean up navigation block when component unmounts to prevent stale callbacks
    const { onBlockNavigation, name } = this.props;
    if (onBlockNavigation && this.state.hasEdit) {
      onBlockNavigation(false, name, null);
    }
  }

  detectEdits(compare: any) {
    if (!compare) return false;

    const { onBlockNavigation, onEditStateChange, name } = this.props;
    const { existing, editing, members } = compare;
    let hasEdit = false;
    members.forEach((member: any) => {
      if (!hasEdit && this.detectEdit(existing, editing, member)) {
        hasEdit = true;
      }
    });

    if (this.state.hasEdit !== hasEdit) {
      if (onEditStateChange) onEditStateChange(hasEdit);
      this.setState({ hasEdit });
    }
    if (onBlockNavigation)
      onBlockNavigation(hasEdit, name, () =>
        this.setState({ showNavigateAwayConfirmation: true })
      );
  }

  detectEdit(existing: any, editing: any, member: any) {
    if (!editing) return false;

    const existingVal = existing ? existing[member.name] : null;
    const isNew =
      !existing || existingVal === null || existingVal === undefined;
    const editingVal = editing ? editing[member.name] : null;
    const isCleared =
      !isNew && (editingVal === null || editingVal === undefined);

    if (member.detectEdit && typeof member.detectEdit === "function")
      return member.detectEdit(existing, editing, isNew, isCleared);

    if (isNew && (editingVal === null || editingVal === undefined))
      return false;

    //Arrays
    if (Array.isArray(existingVal) && Array.isArray(editingVal)) {
      if (existingVal.length === 0 && editingVal.length === 0) return false;
      if (existingVal.length !== editingVal.length) return true;

      if (member.arrayMatch && typeof member.arrayMatch === "function") {
        for (const i1 of existingVal) {
          if (!editingVal.some((i2) => member.arrayMatch(i1, i2))) {
            return true;
          }
        }
        return false;
      }
    }

    //Dates
    if (existingVal instanceof Date && editingVal instanceof Date) {
      if (member.detectEdit === "compareDay") {
        return !EditTemplate.isSameDay(existingVal, editingVal);
      }
      return existingVal.toString() !== editingVal.toString();
    }

    if (isNew && typeof editingVal === "string")
      return editingVal && editingVal.length !== 0;
    return editingVal !== existingVal;
  }

  static isSameDay(d1: any, d2: any) {
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getDate() === d2.getDate() &&
      d1.getMonth() === d2.getMonth()
    );
  }

  onCloseNavigateAwayConfirmation(e: any) {
    this.setState({ showNavigateAwayConfirmation: false });
  }

  onAcceptNavigateAwayConfirmation(e: any) {
    const { onAllowNavigation } = this.props;
    if (onAllowNavigation) onAllowNavigation(e);
    this.setState({ showNavigateAwayConfirmation: false });
  }

  render() {
    const { children, theme } = this.props;
    const { showNavigateAwayConfirmation, hasEdit } = this.state;

    return (
      <>
        {children}

        {hasEdit && <div></div>}

        {showNavigateAwayConfirmation && (
          <ConfirmationDialog
            title={this.props.unsavedChangesTitle || "Unsaved changes"}
            question={
              this.props.unsavedChangesQuestion ||
              "You have unsaved changes that will be lost if you leave this page without saving them. Are you sure you want to leave this page?"
            }
            acceptButton={this.props.unsavedChangesAcceptButton || "Leave page"}
            cancelButton={this.props.unsavedChangesCancelButton || "Cancel"}
            onCancel={this.onCloseNavigateAwayConfirmation.bind(this)}
            onAccept={this.onAcceptNavigateAwayConfirmation.bind(this)}
            theme={theme}
          />
        )}
      </>
    );
  }
}
